import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "@/lib/utils";
import { Typography } from "@bookips/sds";
import { RadiusBoxStyle } from "..";
import PaymentWidget from "../pg/PaymentWidget";
import { SubscriptionBilling } from "./SubscriptionBilling";
/**
 * 결제방법 카드
 *
 * 일반 결제는 PaymentWidget이 자기 DOM 노드를 렌더하고 그 위에 토스 결제위젯을 올린다.
 * 월구독은 위젯 대신 결제수단 선택 + 필수 약관 동의 UI를 직접 렌더한다.
 */ export const CheckoutPaymentMethodSection = (param)=>{
    let { isBilling , finalPrice , mount , billing  } = param;
    return(// 토스 위젯이 자체 마진을 갖고 있어 컨테이너 패딩·갭은 제거하고 자식이 직접 패딩을 잡는다
    /*#__PURE__*/ _jsxs(RadiusBoxStyle, {
        className: "gap-0 overflow-hidden p-0 max-sm:p-0",
        children: [
            /*#__PURE__*/ _jsxs(Typography, {
                variant: "h6",
                className: cn("flex items-center gap-2 px-6 pt-6 max-sm:px-5", finalPrice === 0 && "py-6 max-sm:py-6"),
                children: [
                    "결제방법",
                    !isBilling && finalPrice === 0 && /*#__PURE__*/ _jsx(Typography, {
                        variant: "body1",
                        className: "text-secondary",
                        children: "남은 결제금액이 없어요."
                    })
                ]
            }),
            isBilling ? /*#__PURE__*/ _jsx(SubscriptionBilling, {
                method: billing.method,
                onMethodChange: billing.setMethod,
                agreements: billing.agreements,
                allChecked: billing.isAllAgreed,
                onToggleTerm: billing.toggleTerm,
                onToggleAllTerms: billing.toggleAllTerms
            }) : /* 결제에 필요한 모든 정보가 준비되었을 때만 위젯을 마운트합니다.
           key가 바뀌면 PaymentWidget이 언마운트→마운트되며 destroy 후 재렌더한다. */ finalPrice > 0 && mount && /*#__PURE__*/ _jsx(PaymentWidget, {
                ...mount.props
            }, mount.key)
        ]
    }));
};
